import { useStorePath } from '~/shared/hooks/useStorePath';

export const useDynamicHooks = () => {
    useStorePath;
};
